import request from '@/api/request'

export default {
  async getColors () {
    return (await request.get(`module/action/marketplace/centauro/color`)).data
  },
  async getSizes () {
    return (await request.get(`module/action/marketplace/centauro/size`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/centauro/index.js